import { forwardRef } from "react";

import { styled } from "@mui/material/styles";
import { MaterialDesignContent } from "notistack";

const CustomizedComponent = styled(MaterialDesignContent)({
  "&.notistack-MuiContent": {
    fontSize: "24px",
    fontWeight: "300",
    userSelect: "none",
    paddingRight: "24px",
    paddingBottom: "8px",
  },
  "#notistack-snackbar > svg": {
    fontSize: "28px !important",
  },
});

const OmniSnackbar = forwardRef(function OmniSnackbar(props, ref) {
  return <CustomizedComponent {...props} ref={ref} />;
});

export default OmniSnackbar;
